import { CssBaseline, ThemeProvider as MuiThemeProvider, createTheme, responsiveFontSizes } from '@mui/material';
import { enUS as coreEnUS, frFR as coreFrFR } from '@mui/material/locale';
import { enUS, frFR } from '@mui/x-data-grid/locales';
import { ReactNode, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { allThemes } from 'src/themes';
import { currentLocaleState, currentThemeNameState } from '../atoms';

export const ThemeProvider: React.FC<{ children: ReactNode; }> = ({ children }) => {
  const currentThemeName = useAtomValue(currentThemeNameState) as keyof typeof allThemes;
  const currentLocale = useAtomValue(currentLocaleState);

  const currentThemeObj = allThemes[currentThemeName] ?? allThemes.default;

  const currentTheme = useMemo(() => responsiveFontSizes(createTheme(
    currentThemeObj,
    currentLocale.includes('fr') ? frFR : enUS,
    currentLocale.includes('fr') ? coreFrFR : coreEnUS,
  )), [currentThemeObj, currentLocale]);


  return (
    <MuiThemeProvider theme={currentTheme}>
      <CssBaseline />

      {children}
    </MuiThemeProvider>
  );
};